import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import axios from 'axios';
import WithLoading from '../WithLoading/WithLoading';
import ConsentFormWithData from './ConsentFormWithData';
import ShowError from '../ShowError/ShowError';

const ShowConsentFormWithLoading = WithLoading(ConsentFormWithData);

function ConsentForm({t, setConsentSubmitted}) {
  const [data, setData] = useState({ firstName: '', lastName: '', consent: false });
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const params = new URLSearchParams(window.location.search);
  const id = params.get("id");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_API_URL + `/qr/info/contact/STI%23` + encodeURIComponent(id) + '?time=' + Date.now(), {timeout: 30000});
        setData(d => ({...d, "firstName": response.data.firstName, "lastName": response.data.lastName}));
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setErrorMessage(t("error.loading"));
        setLoading(false);
      }
    };

    fetchData();
  }, [id, t]);

  if (errorMessage) {
    return <ShowError error_msg={errorMessage} />;
  }
  return (
    <div className="centered-spinner">
      <ShowConsentFormWithLoading isLoading={loading} data={data} setData={setData} setConsentSubmitted={setConsentSubmitted} setErrorMessage={setErrorMessage} />
    </div>
  );
}

export default withTranslation()(ConsentForm);
